<div class="ttmodal" >
  <div class="ttmodal__header">
    <span class="ttmodal__title">
      {{ "Calculate Worn" | translate | async }}
    </span>
    <i class="material-icons ttmodal__close-button" (click)="onNoClick()" matTooltip="Close">close</i>
  </div>
  <div class="ttmodal__body" *ngIf="IsRSH==false">

    <!--<div style="display: none;">
      <mat-form-field>
        <mat-select placeholder="Select Unit of Measurement" [(ngModel)]="UOM">
          <mat-option *ngFor="let uom of UnitOfMeasurement" [value]="uom.Id">
            {{ uom.UOM }}
          </mat-option>-->
          <!--<mat-option [value]="1">MM</mat-option>
          <mat-option [value]="2">INCH</mat-option>-->
        <!--</mat-select>
      </mat-form-field>
    </div>-->

    <div>
      <mat-form-field>
        <mat-select placeholder="Select Tool" [(ngModel)]="toolId">
        <mat-option *ngFor="let tool of Component.PossibleTools" [value]="tool.ToolId">
        {{ tool.ToolName }}
        </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div>
      <!-- <span>Measurement</span>
      <input  style="width: 100px;" type="number" [(ngModel)]="Measurement" > -->

      <mat-form-field class="example-full-width">
        <input matInput placeholder="Measurement" [(ngModel)]="Measurement" >
      </mat-form-field>
    </div>
    <div>
      <!-- <span>Calculate Worn</span>
      <input  style="width: 100px;" type="number" [(ngModel)]="Worn"  [disabled] > -->

      <mat-form-field class="example-full-width">
        <input matInput placeholder="Calculate Worn" [(ngModel)]="Worn" [disabled]="true" style="color:black">
      </mat-form-field>
    </div>
  </div>

  <div class="ttmodal__body" *ngIf="IsRSH==true && MainMeasurment!=null">

 
<span>{{MainMeasurment.Name}} </span>

<!--<div>
  <mat-form-field>
    <mat-select placeholder="Select Unit of Measuremen" [(ngModel)]="UOM" >
      <mat-option [value]="1">MM</mat-option>
      <mat-option [value]="2">INCH</mat-option>
    </mat-select>
  </mat-form-field>
</div>-->

    <div>
      <mat-form-field>
        <mat-select placeholder="Select Tool" [(ngModel)]="toolId">
        <mat-option *ngFor="let tool of MainMeasurment.possibletools" [value]="tool.ToolId">
        {{ tool.ToolName }}
        </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div>
      <!-- <span>Measurement</span>
      <input  style="width: 100px;" type="number" [(ngModel)]="Measurement" > -->

      <mat-form-field class="example-full-width">
        <input matInput placeholder="Measurement" [(ngModel)]="Measurement" >
      </mat-form-field>
    </div>
    <div>
      <!-- <span>Calculate Worn</span>
      <input  style="width: 100px;" type="number" [(ngModel)]="Worn"  [disabled] > -->

      <mat-form-field class="example-full-width">
        <input matInput placeholder="Calculate Worn" [(ngModel)]="Worn" [disabled]="true" style="color:black">
      </mat-form-field>
    </div>
  </div>
  <div class="ttmodal__footer">
    <button mat-raised-button color="warn"   (click)="CalculateWorn()"><span class="material-icons button__icon">check</span><span class="button__text">{{ 'Calculate' | translate | async }} </span></button>
    <button mat-raised-button (click)="save()"> {{ 'Save' | translate | async }}</button>
  </div>
</div>
